import { type WPPostType } from '@/defs/wordpress'

import styles from './ArticleMedia.module.scss'

type Props = {
  article?: WPPostType
}

export const ArticleMedia = ({ article }: Props) => {
  const { featuredImageUrl, shortTitle, title } = article || {}

  const articleTitle = shortTitle || title
  const src = featuredImageUrl?.full

  return (
    src && (
      <div className={styles.container}>
        <img alt={`Background image for ${articleTitle}`} className={styles.media} src={src} />
      </div>
    )
  )
}
